import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit"]

  connect() {
    this.setSubmitState()
    this.addEventListeners()
  }

  addEventListeners() {
    this.requiredFields.forEach(element => {
      ["change", "input"].forEach(event => {
        element.addEventListener(event, this.setSubmitState.bind(this))
      })
    })
  }

  addRequired(event) {
    this.element.querySelectorAll(event.params.querySelector).forEach(elem => {
      elem.required = true
      elem.classList.add(".required")
    })
  }

  removeRequired(event) {
    this.element.querySelectorAll(event.params.querySelector).forEach(elem => {
      elem.required = false
      elem.classList.remove(".required")
    })
  }

  setSubmitState() {
    if (!this.hasSubmitTarget) {
      return
    }

    this.submitTarget.disabled = !this.requiredFieldsPresent
  }

  get requiredFields() {
    return [...this.element.querySelectorAll(".form-control.required")]
  }

  get requiredFieldsPresent() {
    return !this.requiredFields.find(field => {
      return !(field.value && field.value.length > 0)
    })
  }
}
